
import { Component, Vue, Prop, Watch, InjectReactive } from "vue-property-decorator"

import { get, set } from "lodash"

// @ts-ignore
import { Datetime } from "vue-datetime"
import vSelect from "vue-select"

import SkeletonLoader from "@/components/SkeletonLoader.vue"

import {
	getEnhancedMapping,
	IEnhancedMapping,
	IMap,
	IMarker,
	ILatLng,
	ILatLngBounds,
	MultiMarker,
	MarkerType,
	IPolygon,
	extend
} from "@sureview/v2-mapping"

import { MapProvider, DrawArguments, MarkerDrawType } from "@/services/mapProvider"

@Component({
	components: {
		"skeleton-loader": SkeletonLoader
	}
})
export default class MapSearchBounds extends Vue {
	$refs!: {
		mappingContainer: HTMLElement,
	}

	@Prop()
	value!: string;

	public enhancedMapping: IEnhancedMapping | null = null;
	public map: IMap | null = null;

	public mapKey: string = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || "";
	private currentDrawing: MultiMarker | null = null;
	private searchBounds: IPolygon | null = null;

	private showMap: boolean = false;

	get markerType () {
		return new MarkerType({
			imageUrl: "./images/map/green_small.svg",
			opacity: 0,
			line: {
				color: "#4CAF50",
				linePath: "solid"
			},
			fill: {
				color: "#4CAF50",
				opacity: 0.3
			}
		}, {
			first: {
				imageUrl: "./images/map/green_small.svg",
				opacity: 1,
				line: {
					color: "#4CAF50",
					linePath: "solid"
				}
			}
		})
	}

	@Watch("value")
	onValueChanged () {
		if (this.searchBounds) {
			this.searchBounds.remove()
			this.searchBounds = null
		}

		if (this.map && this.value && this.value !== "") {
			var regionPoints = JSON.parse(this.value)

			this.searchBounds = this.enhancedMapping!.createPolygon(this.map!,
				regionPoints,
				this.markerType,
				() => {})
		}
	}

	async mounted () {
		this.enhancedMapping = await getEnhancedMapping("google", this.mapKey)

		this.map = this.enhancedMapping.createMultipleMap(
			this.$refs.mappingContainer,
			{ lat: 0, lng: 0 },
			1,
			false,
			"roadmap",
			null
		)

		this.map!.registerEvent("onClick", this.mapClick)
		this.map!.setCursor("crosshair")

		if (this.value && this.value !== "") {
			var regionPoints = JSON.parse(this.value)

			this.searchBounds = this.enhancedMapping.createPolygon(this.map,
				regionPoints,
				this.markerType,
				() => {})

			let bounds: ILatLngBounds | null = null
			regionPoints.forEach((vertexPosition: ILatLng) => {
				bounds = extend(bounds || {} as ILatLngBounds, vertexPosition)
			})

			this.map.zoom = 16

			if (bounds != null) {
				Vue.nextTick().then(() => {
					this.map!.zoom = 16

					Vue.nextTick().then(() => {
						this.map!.mapBounds = bounds!
					})
					this.showMap = true
				})
			}
		} else {
			navigator.geolocation.getCurrentPosition((pos: any) => {
					this.map!.center = {
						lat: pos.coords.latitude,
						lng: pos.coords.longitude
					}
					this.map!.zoom = 16
					this.showMap = true
			}, () => {
				this.showMap = true
			})
		}
	}

	beforeDestroy () {
		if (this.currentDrawing) {
			this.currentDrawing.remove()
			this.currentDrawing = null
		}

		if (this.searchBounds) {
			this.searchBounds.remove()
			this.searchBounds = null
		}

		if (this.map) {
			this.enhancedMapping!.releaseMultipleMap(this.map)
		}
	}

	mapClick (clickLocation: { lat: number, lng: number }) {
		if (!this.currentDrawing) {
			if (this.searchBounds) {
				this.searchBounds.remove()
				this.searchBounds = null
			}

			this.currentDrawing = new MultiMarker(this.enhancedMapping!,
				this.map!,
				"",
				this.markerType,
				[clickLocation],
				(clickedMarker: IMarker, index: number) => {
					if (index === 0) {
						this.$emit("input",
							this.currentDrawing!.lineMarkers.map((m: any) => m.position))

						Vue.nextTick().then(() => {
							if (this.currentDrawing) {
								this.currentDrawing.remove()
								this.currentDrawing = null
							}
						})
					}
				}
			)
		} else {
			this.currentDrawing.addPoint(clickLocation)
		}
	}
}

